import React, { Dispatch, SetStateAction } from 'react'
import * as Yup from 'yup';
import { Modal, Row } from 'antd'
import { Button, FormatText, FormSubmitButton, FormTextArea, MasterDetailForm, Widget } from '@digital/ui'
import { UploadMultipleTable, Visibility } from '@app/components';
import { avancarAprovacaoGerenteMinimoProponentes } from '@app/api/sas/ordemCompra';
import { ordemCompraIdState, reloadVendorListState } from '../atoms'
import { useRecoilState, useRecoilValue } from 'recoil';

interface Props {
    exibirModal: boolean;
    setExibirModal: Dispatch<SetStateAction<boolean>>;
}

const ModalAprovacaoProponentes = (props: Props) => {
    const { exibirModal, setExibirModal } = props;

    const ordemCompraId = useRecoilValue(ordemCompraIdState);
    const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);

    const onCancel = () => {
        setExibirModal(false)
    }

    const onSubmit = (values: any) => {
        const form = new FormData();
        form.append('id', ordemCompraId);
        values.arquivos.map((c, i) => {
            form.append("arquivos", c);
        })
        form.append('justificativa', values.justificativa);
        avancarAprovacaoGerenteMinimoProponentes(form)
            .then((data: any) => {
                if (data.valid) {
                    setReloadVendorList(!reloadVendorList);
                    setExibirModal(false)
                }
            })
    }

    return (
        <Visibility visible={exibirModal}>

            <Modal
                title='Solicitação de aprovação do Gerente'
                width='780px'
                visible={exibirModal}
                onCancel={onCancel}
                footer={null}
            >

                <MasterDetailForm
                    key="formAprovacaoProponentesGerente"
                    onSubmit={onSubmit}
                    validationSchema={Yup.object().shape({
                        justificativa: Yup.string()
                            .required('Justificativa deve ser informado')
                            .max(2000, 'Nome deve ter no máximo 2000 caracteres')
                    })}
                    actions={[
                        <Button title='Fechar' onClick={() => onCancel()} type="link" />,
                        <FormSubmitButton noIcon type="primary">
                            <FormatText id="ui.commons.save" uppercase />
                        </FormSubmitButton>
                    ]} >
                    <Widget >
                        <Row>
                            <FormTextArea name='justificativa' label='Justificativa' span={12} rows={3} />
                        </Row>
                        <Row>
                            <UploadMultipleTable idDoComponente='uploadModalMinimoProponentes' name='arquivos' type="primary" />
                        </Row>
                    </Widget>
                </MasterDetailForm>

            </Modal>

        </Visibility>
    )
}

export default ModalAprovacaoProponentes